import { Injectable } from "@angular/core";
import * as CryptoJS from "crypto-js";

@Injectable({
  providedIn: "root",
})
export class EncryptionService {
    
  constructor() {}

  encrypt(value: any, secretKey: any, _iv: any) {
    secretKey = CryptoJS.enc.Utf8.parse(secretKey);
    _iv = CryptoJS.enc.Utf8.parse(_iv);
    let hasedPass = CryptoJS.SHA256(`change${value}`).toString();
    let hash = CryptoJS.AES.encrypt(
      CryptoJS.enc.Utf8.parse(hasedPass),
      secretKey,
      {
        keySize: 128 / 8,
        iv: _iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );

    return hash ? hash.toString() : "";
  }

  decrypt(encvalue: any, secretKey: any, _iv: any) {
    secretKey = CryptoJS.enc.Utf8.parse(secretKey);
    _iv = CryptoJS.enc.Utf8.parse(_iv);
    let decryptVal = CryptoJS.AES.decrypt(encvalue, secretKey, {
      keySize: 128 / 8,
      iv: _iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    return decryptVal ? decryptVal.toString(CryptoJS.enc.Utf8) : "";
  }
}
